export enum SubscriptionPlanStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}
